Ext.define('SA.view.MenuButton', {
    alias: 'widget.sa-menu-button',
    extend: 'SA.view.Button',
    mixins: ['SA.view.mixin.ChildItems', 'Ext.Queryable'],

    arrow: true,
    autoEl: {tabIndex: 0, tag: 'a'},
    maskOnDisable: false,
    menuActiveCls: 'sa-button-menu-active',
    menuAlign: 'tl-bl?',
    menuOffset: [0, 7],
    moveAction: 'align',

    beforeDestroy() {
        this.destroyMenu();

        this.callParent();
    },

    beforeMenuShow(menu) {
        this.fireEvent('beforeshow:menu', menu);
    },

    beforeRender() {
        this.addCls('sa-menu-button');

        this.callParent();
    },

    createMenu(cfg) {
        cfg.target = cfg.target || this;

        var menu = this.menu = Ext.menu.Manager.get(cfg);

        if (!menu.getPlugin('sa-arrow')) {
            menu.addPlugin('sa-arrow');
        }

        menu.ownerButton = this;
        menu.addCls('sa-menu-button-menu');

        if (this.menuCls) {
            menu.addCls(this.menuCls);
        }

        return menu;
    },

    destroyMenu() {
        Ext.destroyMembers(this, 'menu');
    },

    getChildItems() {
        return [this.getMenu(false)];
    },

    getMenu(create) {
        var me = this,
            menu = getMenuOrConfig();

        if (menu && !menu.isMenu) {
            if (create === false) {
                return null;
            }

            menu = this.menu = this.createMenu(menu);

            menu.on({
                beforehide: this.onMenuBeforeHide,
                hide: this.onMenuHide,
                beforeshow: this.beforeMenuShow,
                show: this.onMenuShow,
                scope: this
            });

            SA.view.menu.MenuVisibilityTracker.track(menu);
        }

        return menu;

        function getMenuOrConfig() {
            var menu = me.menu;

            if (!menu || menu.isDestroyed) {
                menu = me.getMenuConfig();
            }

            return menu;
        }
    },

    getMenuConfig() {
        return this.menuCfg || {};
    },

    getMenuItemByItemId(itemId) {
        var menuItems = this.getMenu(true).items.items;

        return menuItems.find(menuItem => menuItem.getItemId() === itemId);
    },

    initEvents() {
        this.callParent();

        this.getEl().on('keydown', this.onKeyDown, this);
        this.on('move', this.onMove, this);
        this.mon(SA.Viewport, 'resize', this.onResize, this, {buffer: 100});
    },

    onClick() {
        if (this.disabled) {
            return;
        }

        var byClick = true,
            menu = this.getMenu();

        this.callParent();

        if (menu) {
            if (SA.view.menu.MenuVisibilityTracker.wasRecentlyVisible(menu)) {
                menu.hide();
            }
            else {
                this.showMenu(byClick);
            }
        }
    },

    onKeyDown(ev) {
        var keyCode = ev.getKey();

        if (keyCode === ev.ENTER || keyCode === ev.SPACE) {
            this.showMenu();
        }
    },

    onMenuBeforeHide() {
        this.el.focus();
    },

    onMenuHide() {
        this.removeCls(this.menuActiveCls);
    },

    onMenuShow() {
        this.addCls(this.menuActiveCls);
    },

    onMove() {
        var menu = this.getMenu(false);

        if (menu && !menu.isHidden()) {
            switch (this.moveAction) {
                case 'align':
                    this.showMenu();
                break;
                case 'hide':
                    menu.hide();
                break;
            }
        }
    },

    onResize() {
        this.onMove();
    },

    setMenuCfg(cfg) {
        this.destroyMenu();

        this.menuCfg = cfg;
    },

    showMenu() {
        this.getMenu().showBy(this.el, this.menuAlign, this.menuOffset);
    }
});
